import type {
  ApiDocument,
  CombinedItem,
  CommunicationDetails,
  SharedItemsCollection,
  SharedItemsReturnType,
} from '@izimi/api';
import { sharedItemsCollection } from '@izimi/api';

import { BaseCommunicationDetailsEntity, mapCommunicationToEntity } from '../communications';
import { DocumentEntity } from '../documents';

export const isCommunicationDetails = (
  item: CombinedItem<SharedItemsReturnType, SharedItemsCollection>,
): item is CommunicationDetails =>
  item._collection === sharedItemsCollection.NOT_EXPIRING_COMMUNICATION_DETAILS ||
  item._collection === sharedItemsCollection.EXPIRING_COMMUNICATION_DETAILS;
export const isDocument = (
  item: CombinedItem<SharedItemsReturnType, SharedItemsCollection>,
): item is ApiDocument =>
  item._collection === sharedItemsCollection.PUSHED_DOCUMENTS ||
  item._collection === sharedItemsCollection.SHARED_DOCUMENTS;

export const mapSharedItemsToEntities = ({
  items,
}: {
  items: CombinedItem<SharedItemsReturnType, SharedItemsCollection>[];
}): Array<DocumentEntity | BaseCommunicationDetailsEntity> =>
  items
    ?.map((item) => {
      if (isCommunicationDetails(item)) {
        return mapCommunicationToEntity(item, item._collection?.toString());
      }
      if (isDocument(item)) {
        return new DocumentEntity(item, item._collection?.toString());
      }
      return null;
    })
    .filter((item): item is NonNullable<typeof item> => item != null);
